/* eslint-disable max-classes-per-file */
class ExperienceCardItemInterface {
  name: string;

  slug: string;

  areaName: string;

  areaSlug: string;

  cityName: string;

  citySlug: string;

  countryName: string;

  countrySlug: string;

  tier: string;

  ticketType: string;

  isFavourite: boolean;

  isExclusive: boolean;

  klubCategory: string;

  categoty: string;

  photos: string;

  rating: string;

  numReview: string;

  prices: {
    id: number;
    type: string;
    nameEn: string;
    nameTh: string;
    price: number;
    originalPrice: number;
    exclusivePrice: number;
    settlementPrice: number;
    currency: string;
  };

  location: {
    lat: number;
    long: number;
  };

  constructor(data: any) {
    this.name = data.name || "";
    this.slug = data.slug || "";
    this.areaName = data.areaName || "";
    this.areaSlug = data.areaSlug || "";
    this.cityName = data.cityName || "";
    this.citySlug = data.citySlug || "";
    this.countryName = data.countryName || "";
    this.countrySlug = data.countrySlug || "";
    this.tier = data.tier || "";
    this.ticketType = data.ticketType || "";
    this.isFavourite = data.isFavourite || false;
    this.isExclusive = data.isExclusive || false;
    this.klubCategory = data.klubCategory || "";
    this.categoty = data.categoty || "";

    this.photos = data.photos || "";
    this.rating = data.rating || "";
    this.numReview = data.numReview || "";
    this.prices = {
      id: data.prices.id || 0,
      type: data.prices.type || "",
      nameEn: data.prices.nameEn || "",
      nameTh: data.prices.nameTh || "",
      price: data.prices.price || 0,
      originalPrice: data.prices.originalPrice || 0,
      exclusivePrice: data.prices.exclusivePrice || 0,
      settlementPrice: data.prices.settlementPrice || 0,
      currency: data.prices.currency || "",
    };
    this.location = {
      lat: data.location.lat || 0,
      long: data.location.long || 0,
    };
  }
}
export interface ExperienceCardItemResponseInterface {
  status: boolean;
  message: string | null;
  data: ExperienceCardItemClassInterface[];
}

export interface Category {
  name: string;
  slug: string;
}
export interface ExperienceCardItemPrice {
  id?: number;
  type?: string;
  nameEn?: string;
  nameTh?: string;
  price?: number;
  originalPrice?: number;
  exclusivePrice?: number;
  settlementPrice?: number;
  settlementCurrency?: string;
  currency?: string;
  publishStart?: string;
  publishEnd?: string;
  redeemStart?: string;
  redeemEnd?: string;
  redeemDuration?: string;
  ticketValidity?: boolean;
  isCancellable?: boolean;
  cancellationPolicy?: boolean;
  cancellationNotes?: boolean;
  discountPercentage?: number;
  gotherPrice?: number;
  gotherDiscountPercentage?: number;
  packageName?: string;
}
export class ExperienceCardItemClassInterface {
  // default
  experienceId: number;

  name: string;

  title?: string;

  cityName: string;

  countryName: string;

  isGreenCertificate?: boolean;

  slug: string;

  citySlug: string;

  countrySlug: string;

  tier: string;

  ticketType: string;

  isFavourite: boolean;

  isExclusive: boolean;

  exclusive?: boolean;

  isSpecialDeal?: boolean;

  isRecommended?: boolean;

  photos: string[];

  image?: string;

  images?: string;

  rating: string;

  ratingReviews?: string;

  numReview: string;

  price?: number;

  originalPrice?: number;

  currency?: string;

  isSEO?: boolean;

  isSoldOut?: boolean;

  category?: Category[];

  prices: ExperienceCardItemPrice;

  perks: string;

  klubCategory: {
    name: string;
    slug: string;
  };

  location: {
    lat: number;
    long: number;
  };

  // api res
  areaName: string;

  areaSlug: string;

  // custom index
  index?: number;

  id: number;

  constructor(data: any) {
    this.id = data?.id || "";
    this.experienceId = data?.experienceId || "";
    this.name = (data.name ?? data.title) || "";
    this.cityName = data.cityName || "";
    this.countryName = data.countryName || "";
    this.slug = data.slug || "";
    this.citySlug = data.citySlug || "";
    this.countrySlug = data.countrySlug || "";
    this.tier = data.tier || "";
    this.ticketType = data.ticketType || "";
    this.isFavourite = data.isFavourite || false;
    this.isExclusive = (data.isExclusive ?? data.exclusive) || false;
    this.isSpecialDeal = data.isSpecialDeal || false;
    this.isRecommended = data.isRecommended || false;
    this.photos = (data.photos ?? data.image ?? data.images) || [];
    this.images = (data.photos ?? data.image ?? data.images) || "";
    this.isGreenCertificate = data.isGreenCertificate || false;

    this.rating = (data.rating ?? data.ratingReviews) || "";
    this.numReview = data.numReview || "";
    this.prices = {
      id: data.prices?.id || 0,
      type: data.prices?.type || "",
      nameEn: data.prices?.nameEn || "",
      nameTh: data.prices?.nameTh || "",
      price: (data.prices?.price ?? data?.price) || 0,
      originalPrice: (data.prices?.originalPrice ?? data.originalPrice) || 0,
      exclusivePrice: data.prices?.exclusivePrice || "",
      settlementPrice: data.prices?.settlementPrice || "",
      settlementCurrency: data.prices?.settlementCurrency || "",
      currency: (data.prices?.currency ?? data.currency) || "",
      publishStart: (data.prices?.publishStart ?? data.publishStart) || "",
      publishEnd: (data.prices?.publishEnd ?? data.publishEnd) || "",
      redeemStart: (data.prices?.redeemStart ?? data.redeemStart) || "",
      redeemEnd: (data.prices?.redeemEnd ?? data.redeemEnd) || "",
      ticketValidity:
        (data.prices?.ticketValidity ?? data.ticketValidity) || false,
      isCancellable:
        (data.prices?.isCancellable ?? data.isCancellable) || false,
      cancellationPolicy:
        (data.prices?.cancellationPolicy ?? data.cancellationPolicy) || false,
      cancellationNotes:
        (data.prices?.cancellationNotes ?? data.cancellationNotes) || false,
      discountPercentage:
        (data.prices?.discountPercentage ?? data.discountPercentage) || 0,
      packageName: data.prices?.packageName || "",
      gotherDiscountPercentage: data.prices?.gotherDiscountPercentage || 0,
      gotherPrice: data.prices?.gotherPrice || 0,
    };
    this.perks = data.perks ?? "";
    this.klubCategory = {
      name: data.klubCategory?.name || "",
      slug: data.klubCategory?.slug || "",
    };

    this.category = (data.category || []).map((item: any) => {
      return {
        name: item.name || "",
        slug: item.slug || "",
      };
    });
    this.location = {
      lat: data.location.lat || 0,
      long: data.location.long || 0,
    };
    this.areaName = data.areaName || "";
    this.areaSlug = data.areaSlug || "";
    this.index = data.index || 0;
    this.isSEO = data.isSEO || false;
    this.isSoldOut = data.isSoldOut || false;
  }
}

// Helper to normalize photos field into string[]
const normalizePhotos = (value: string | string[] | undefined): string[] => {
  if (Array.isArray(value)) return value;
  if (typeof value === "string") return [value];
  return [];
};

// Transform raw data array to ExperienceCardItemClassInterface[]
export const transformToExperienceItems = (
  rawItems: any[],
): ExperienceCardItemClassInterface[] => {
  return rawItems.map((item, index) => {
    const mergedItem = {
      ...item,
      experienceId: item.id,
      name: item.title || item.name || "",
      photos: normalizePhotos(item.photos || item.image || item.images),
      rating: item.review?.rating?.toString() ?? "0",
      numReview: item.review?.numReviews?.toString() ?? "0",
      prices: {
        ...item.prices,
        price: item.prices?.price ?? item.price ?? 0,
        originalPrice: item.prices?.originalPrice ?? item.originalPrice ?? 0,
        currency: item.prices?.currency ?? item.currency ?? "",
        exclusivePrice: item.prices?.exclusivePrice ?? 0,
        settlementPrice: item.prices?.settlementPrice ?? 0,
      },
      location: {
        lat: item.latitude ?? 0,
        long: item.longitude ?? 0,
      },
      index, // optional index
    };

    return new ExperienceCardItemClassInterface(mergedItem);
  });
};
